<div class="order-receipt-offer-products">
  <ng-container *ngFor="let product of products">
    <span class="order-receipt-offer-product-name ods-typography-body-s-bold">{{ product.name }}</span>
    <span class="order-receipt-offer-product-description ods-typography-body-s-regular">{{ product.description }}</span>
  </ng-container>
</div>
<box-quantity class="order-receipt-offer-quantity" [dense]="true" [disabled]="true" [quantity]="quantity"></box-quantity>
<span class="order-receipt-offer-price ods-typography-body-s-bold">{{ price }}</span>